import { faHandPointRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import errorLogo from './../../images/404.jpg'

const NoMatch = () => {
    return (
        <div className='container-fluid p-5' style={{ marginTop: '80px' }}>
            <img src={errorLogo} alt="logo error" className='img-fluid d-block mx-auto' />
            <h6 className='fs-4 text-center'>We can't find this page please go to  <Link to='/' className='btn btn-danger'>HomePages<FontAwesomeIcon icon={faHandPointRight} className='ms-1' /></Link></h6>
        </div>
    );
};

export default NoMatch;